/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type {TaxAccountantDto} from './TaxAccountantDto';

export type TaxAccountantSettingsDto = {
    /**
     * Permissions defines what operations can logged user processed with this entity.
     */
    readonly _permissions?: Array<string>;
    accountant?: TaxAccountantDto;
    settingsAttribute?: TaxAccountantSettingsDto.attribute;
    /**
     * Date of creation of entity.
     */
    created: string;
    /**
     * Creator (username) of entity.
     */
    creator?: string;
    /**
     * Id of creator of entity.
     */
    creatorId?: string;
    /**
     * Primary key (Id) of entity.
     */
    id: string;
    /**
     * Date of last modification of entity.
     */
    modified?: string;
    /**
     * Modifier (username) of entity.
     */
    modifier?: string;
    /**
     * Id of modifier of entity.
     */
    modifierId?: string;
    /**
     * Original creator (username) of entity. For feature 'login as', when admin can login to the system as other user, but we need to know who is original (real) creator of entity.
     */
    originalCreator?: string;
    /**
     * Original creator (ID) of entity. For feature 'login as', when admin can login to the system as other user, but we need to know who is original (real) creator of entity.
     */
    originalCreatorId?: string;
    /**
     * Original modifier (username) of entity. For feature 'login as', when admin can login to the system as other user, but we need to know who is original (real) modifier of entity.
     */
    originalModifier?: string;
    /**
     * Original modifier (ID) of entity. For feature 'login as', when admin can login to the system as other user, but we need to know who is original (real) modifier of entity.
     */
    originalModifierId?: string;
    settingsValue?: string;
};

export namespace TaxAccountantSettingsDto {

    export enum attribute {
        RECEIPTS_PAID_BY_CARD = 'RECEIPTS_PAID_BY_CARD',
        INVOICES_PAID_BY_CARD = 'INVOICES_PAID_BY_CARD',
        INVOICES_PAID_BY_CASH = 'INVOICES_PAID_BY_CASH',
    }


}

